import { FilterBugetManager } from "../types";

export function bugetMapperPayloadMapper(data: FilterBugetManager) {
  return {
    start_range: data?.start_range,
    end_range: data?.end_range,
    currency: data?.currency,
    AccountGroup: data?.AccountGroup,
  }
}